
export default function timestampToDateString(ts: number, hour = false): string {
    const date = new Date(ts)
    const day = date.getDate()
    const month = date.getMonth() + 1
    const year = date.getFullYear()
    const hours = date.getHours()
    const minutes = date.getMinutes()
    if (!hour) return `${day <= 9 ? `0${day}` : day}/${month <= 9 ? `0${month}` : month}/${year}`

    return `${day <= 9 ? `0${day}` : day}/${month <= 9 ? `0${month}` : month}/${year} - ${
        hours <= 9 ? `0${hours}` : hours
    }:${minutes <= 9 ? `0${minutes}` : minutes}`
}